export default {
  // Login y recuperación de contraseña (migrado desde navigation.js → login)
  login: {
    'username-label': 'Usuario',
    'password-label': 'Contraseña',
    'welcome': 'Bienvenido',
    'login': 'Iniciar Sesión',
    'email': 'Correo electrónico',
    'forgot-password': '¿Olvidaste tu contraseña?',
    'remember-me': 'Recuérdame en este dispositivo',
    'spanish-label': 'Español',
    'english-label': 'Inglés',
    'credentials-alert': 'Credenciales inválidas',
    'ingresarCodigo': 'Ingresar Código',
    'reset-password-title': 'Reinicia tu contraseña',
    'reset-password-subtitle-p1': 'Para restaurar tu contraseña,',
    'reset-password-subtitle-p2': ' ingresa tu dirección de correo electrónico.',
    'reset-password-text': 'Elige el método de reestablecimiento:',
    'reset-password-mail': 'Enviar enlace por Correo electrónico',
    'reset-password-sms': 'Enviar código por mensaje SMS',
    'reset-password-error-email': 'Por favor revise el correo ingresado e intentelo nuevamente',
    'reset-password-sms-title': 'Ingresa el código que enviamos por SMS',
    'reset-password-sms-subtitle': 'Es un código de 6 dígitos enviado al teléfono terminado en',
    'reset-password-mail-success': 'Hemos enviado un enlace a tu correo electrónico',
    'reset-password-mail-success-caption': 'Link con instrucciones enviado al correo electrónico',
    'reset-password-mail-not-recieve': '¿No recibiste el correo?',
    'reset-password-mail-resend': 'Reenviar correo en',
    'reset-password-mail-resend-btn': 'Reenviar correo',
    'reset-password-sms-resend': 'Reenviar código',
    'email-send-success': 'Correo electrónico enviado correctamente, en caso de no recibir el correo, revisar la bandeja de spam.',
    'password-changed-success': 'Contraseña cambiada exitosamente',
    'password-changed-success-info': 'Será reedirigido al módulo de inicio de sesión en: ',
    'continue': 'Continuar',
    'cancel': 'Cancelar',
    'not-you': '¿No eres tú?',
    'back': 'Regresar al inicio',
    'cancel-sms-reset': 'Cancelar y volver al login',
    'create-password': 'Crea tu nueva contraseña',
    'enter-password': 'Ingresa tu nueva contraseña',
    'confirm-password': 'Confirma tu nueva contraseña',
    'change-password': 'Cambiar Contraseña',
    'required-password': 'Tu nueva contraseña debe contener lo siguiente:',
    'biometric-login': 'Iniciar sesión con biometría',
    'biometric-enable-title': 'Habilitar inicio de sesión con datos biométricos.',
    'biometric-enable-message': 'Activa tu huella digital o reconocimiento facial para entrar sin contraseña la próxima vez.',
    'biometric-enable-confirm': 'Activar biométricos',
    'biometric-enable-dismiss': 'Ahora no',
    'biometric-login-error': 'No se pudo verificar tu identidad biométrica',
    'biometric-login-prompt-title': 'Inicio de sesión biométrico',
    'biometric-login-prompt-description': 'Confirma tu identidad para continuar',
    'biometric-enroll-prompt-title': 'Activar inicio biométrico',
    'biometric-enroll-prompt-description': 'Confirma tu identidad para activar el inicio de sesión biométrico',
    'biometric-reenroll-required': 'Tu inicio biométrico expiró, ingresa con tu contraseña para reactivarlo'
  },

  // Formulario de cambio de contraseña (migrado desde profile.js → auth)
  password_form: {
    password: 'Contraseña',
    password_verify: 'Confirmar contraseña',
    change_password: 'Actualizar contraseña',
    save: 'Guardar'
  },

  // Autenticación en dos pasos (migrado desde profile.js — success_2fa/error_2fa/success_deactivate2fa)
  two_factor: {
    success: 'La próxima vez que inicies sesión tendrás que usar el código generado desde google authenticator.',
    deactivated: 'La próxima vez que inicies sesión no se te pedira ingresar el código',
    error: 'El código no es correcto'
  }
}
